module.exports = __webpack_public_path__ + "img/icon3.4436b3e2.png";